import { Tooltip } from 'primereact/tooltip';
import React, { useState } from 'react';

type TooltipPosition = 'left' | 'top' | 'bottom' | 'right' | 'mouse';

interface TooltipIconProps {
  id: string; // Unique id for the tooltip, to avoid multiple renders of the same tooltip
  tooltipText?: string; // The text to display in the tooltip
  position?: TooltipPosition; // Tooltip position (optional, defaults to 'left')
  iconClass?: string; // Custom icon class (optional, defaults to 'pi pi-question-circle')
  icon?: JSX.Element; // Icon component (optional)
  hoverIcon?: JSX.Element; // Icon component to show on hover (optional)
  template?: React.ReactNode; // Custom template for the tooltip (unless tooltipText is provided)
  autoHide?: boolean;
  width?: string;
}

const TooltipIcon: React.FC<TooltipIconProps> = ({
  id,
  tooltipText,
  position = 'left',
  iconClass = 'pi pi-question-circle',
  icon,
  hoverIcon,
  template,
  autoHide = true,
  width = '15rem',
}) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const onMouseEnter = (): void => {
    setIsHovered(true);
  };

  const onMouseLeave = (): void => {
    setIsHovered(false);
  };

  return (
    <>
      <Tooltip
        className={`w-${width}`}
        target={`.tooltip-icon-${id}`}
        pt={{
          text: { className: 'opacity-100' },
        }}
        autoHide={autoHide}
        content={tooltipText}
        position={position}
      >
        {/* Template is the custom content. Provide a ReactNode if the content is not just text. Otherwise, use tooltipText prop for texts */}
        {template}
      </Tooltip>

      {/* If a custom icon object is provided, use it as the target. Otherwise use the default 'question mark' PrimeIcon */}
      {icon ? (
        <div
          className={`tooltip-icon-${id} flex`}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          {isHovered ? hoverIcon ?? icon : icon}
        </div>
      ) : (
        <i className={`tooltip-icon-${id} cursor-pointer ${iconClass}`} />
      )}
    </>
  );
};

export default TooltipIcon;
